module.exports = __webpack_public_path__ + "img/huodong_title_zhuti@2x.0e52fd59.png";